import {
  useUserDataContext,
  itemDataFromDynamo,
  useAccountContext,
  SearchMatchGroup,
  SEARCH_MATCH_GROUP_LABELS,
} from "../../contexts/index";
import {
  DeleteItemPopup,
  SelectLocationPopup,
  SelectMoveOrUsePopup,
  LoadingPopup,
} from "../../components/modals/index";
import {
  ItemFormUpgradePopup,
  BulkWorkflowFormPopup,
} from "../../components/forms/index";
import {
  InUseIcon,
  InUseNoteText,
  LocationIcon,
  StyledCard,
  StyledCardHeader,
  SEARCH_MATCH_GROUP_COLORS,
} from "../../styles/components/Cards.styled";
import {
  Button,
  CardButton,
  CardButtonTitle,
  LongerCardButton,
} from "../../styles/components/Buttons.styled";
import {
  ButtonsContainer,
  CardContainer,
  LoadMoreContainer,
  SearchGroupHeader,
} from "../../styles/components/Containers.styled";
import { GeoAlt, BagCheck } from "react-bootstrap-icons";
import { Fragment, useEffect, useState } from "react";
import { UNTITLED } from "../../utils/index";
import { ImageModal } from "../../components/common/index";

let httpMethod: string = "";
let currentItemId: string = "";

export default function MyItems(props: { alrt: string | null }) {
  const {
    curItemArray,
    curParent,
    itemMap,
    parentMap,
    setParentToBe,
    setCurItemData,
    itemToDelete,
    itemToMove,
    setItemToMove,
    itemToMoveOrUse,
    setItemToMoveOrUse,
    upgradedItemFormOpen,
    setupgradedItemFormOpen,
    searchActive,
    recalculateCurrentArray,
    CancelSearch,
    isLoading,
    itemsInView,
    setItemsInView,
    subscriptionExpired,
    bulkWorkflow,
    multiSelectMode,
    setMultiSelectMode,
    selectedItemsToMove,
    setSelectedItemsToMove,
    pendingPreviews,
    searchMatchGroups,
  } = useUserDataContext();
  const [quantityCount, setQuantityCount] = useState<Number>(0);

  // Number of results in each search match group, for the group headers
  const searchGroupCounts: Partial<Record<SearchMatchGroup, number>> = {};
  if (searchActive) {
    curItemArray.forEach((item) => {
      const group = searchMatchGroups[item.ItemId];
      if (group != null) {
        searchGroupCounts[group] = (searchGroupCounts[group] ?? 0) + 1;
      }
    });
  }

  // Search match group of an item in the current results, if any
  function getSearchGroup(itemId: string): SearchMatchGroup | undefined {
    return searchActive ? searchMatchGroups[itemId] : undefined;
  }

  // Returns the group header to show before the item at this index, if it starts a new group
  function getSearchGroupHeader(index: number) {
    const group = getSearchGroup(curItemArray[index].ItemId);
    if (group == null) return null;
    const prevGroup =
      index > 0 ? getSearchGroup(curItemArray[index - 1].ItemId) : undefined;
    if (group === prevGroup) return null;
    return (
      <SearchGroupHeader $accent={SEARCH_MATCH_GROUP_COLORS[group].accent}>
        {SEARCH_MATCH_GROUP_LABELS[group]} ({searchGroupCounts[group]})
      </SearchGroupHeader>
    );
  }

  // Toggle item selection in multi-select mode
  function toggleItemSelection(itemId: string) {
    if (selectedItemsToMove.includes(itemId)) {
      setSelectedItemsToMove(selectedItemsToMove.filter(id => id !== itemId));
    } else {
      setSelectedItemsToMove([...selectedItemsToMove, itemId]);
    }
  }

  // Cancel multi-select mode
  function cancelMultiSelect() {
    setMultiSelectMode(false);
    setSelectedItemsToMove([]);
  }

  // Open location selector to move all selected items
  function moveSelectedItems() {
    if (selectedItemsToMove.length > 0) {
      // Set the first selected item as itemToMove to open the location selector
      setItemToMove(selectedItemsToMove[0]);
    }
  }

  function editItem(item: itemDataFromDynamo) {
    httpMethod = "PUT";
    currentItemId = item.ItemId;
    setParentToBe(item.ParentId);
    setCurItemData(item);
    setupgradedItemFormOpen(true);
  }

  //Prevent background from scrolling when edit modal is open
  useEffect(() => {
    if (upgradedItemFormOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [upgradedItemFormOpen]);

  function changeView(itemId: string, item: itemDataFromDynamo) {
    CancelSearch();
    recalculateCurrentArray(parentMap, itemId, itemMap, false);
  }

  useEffect(() => {
    if (props.alrt != null) {
      if (props.alrt == "success") {
        alert("Thank you for your subscription!");
      }
    }
  }, []);

  useEffect(() => {});

  // Recalculate the visible item list on mount so any items synced while
  // the user was on another page (e.g. drained from the offline queue) appear.
  useEffect(() => {
    recalculateCurrentArray(parentMap, curParent, itemMap);
  }, []);

  return (
    <>
      <div>
        {upgradedItemFormOpen && (
          <ItemFormUpgradePopup
            httpMethod={httpMethod}
            itemId={currentItemId}
          />
        )}
        {bulkWorkflow && <BulkWorkflowFormPopup />}
        {itemToDelete != "" && <DeleteItemPopup />}
        {itemToMove != "" && <SelectLocationPopup />}
        {itemToMoveOrUse != "" && <SelectMoveOrUsePopup />}
        {isLoading && <LoadingPopup message={isLoading} />}
        <div style={multiSelectMode ? { paddingBottom: '100px' } : {}}>
          <CardContainer>
            {curItemArray.length > 0 &&
              curItemArray.slice(0, itemsInView).map((item, index) => (
                <Fragment key={index}>
                {getSearchGroupHeader(index)}
                <StyledCard
                  style={{
                    ...(multiSelectMode ? { border: selectedItemsToMove.includes(item.ItemId) ? '3px solid #608cdf' : '3px solid transparent' } : {}),
                    ...(getSearchGroup(item.ItemId) != null ? { backgroundColor: SEARCH_MATCH_GROUP_COLORS[getSearchGroup(item.ItemId)!].background } : {}),
                  }}
                >
                  {multiSelectMode ? (
                    <>
                      <div style={{ fontSize: '1.2rem', fontWeight: 'bold', padding: '10px', color: '#608cdf', textAlign: 'center' }}>
                        {item?.Name != null && item.Name.trim() != ""
                          ? item.Name
                          : UNTITLED}
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '10px', gap: '8px' }}>
                        <label style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', color: '#608cdf', fontWeight: '600' }}>
                          <input
                            type="checkbox"
                            checked={selectedItemsToMove.includes(item.ItemId)}
                            onChange={() => toggleItemSelection(item.ItemId)}
                            style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                          />
                          Move this item
                        </label>
                      </div>
                    </>
                  ) : (
                    <StyledCardHeader>
                      {parentMap[item.ItemId] != null && (
                        <LocationIcon>
                          <h2>
                            <GeoAlt />
                          </h2>
                        </LocationIcon>
                      )}
                      <CardButtonTitle
                        onClick={() => changeView(item.ItemId!, item)}
                      >
                        {item?.Name != null && item.Name.trim() != ""
                          ? item.Name
                          : UNTITLED}
                        <br />
                        View Items
                      </CardButtonTitle>
                      {item.InUse && (
                        <InUseIcon
                          title={
                            item.InUseNote
                              ? `In use: ${item.InUseNote}`
                              : "In use"
                          }
                        >
                          <h2>
                            <BagCheck />
                          </h2>
                        </InUseIcon>
                      )}
                    </StyledCardHeader>
                  )}
                  <ImageModal
                    src={pendingPreviews[item.ItemId] ?? (item.Image ? item.Image + "_mainimg.jpeg" : undefined)}
                    quantity={item.Quantity}
                  />
                  {!multiSelectMode && item.InUse && item.InUseNote && (
                    <InUseNoteText>In use: {item.InUseNote}</InUseNoteText>
                  )}
                  {!multiSelectMode && (
                    <ButtonsContainer>
                      <CardButton onClick={() => editItem(item)}>
                        View / Edit / Delete Item
                      </CardButton>
                      <CardButton
                        onMouseUp={() => setItemToMoveOrUse(item.ItemId!)}
                      >
                        Move / Use Item
                      </CardButton>
                      {searchActive && (
                        <LongerCardButton
                          onClick={() => {
                            changeView(
                              item.ParentId != null &&
                                itemMap[item.ParentId] != null
                                ? itemMap[item.ParentId].ItemId!
                                : "MASTER",
                              item
                            );
                          }}
                        >
                          View Items in{" "}
                          {item != null &&
                          item.ParentId != null &&
                          itemMap[item.ParentId] != null &&
                          itemMap[item.ParentId].Name != null
                            ? itemMap[item.ParentId].Name
                            : item != null &&
                              item.ParentId != null &&
                              item.ParentId == "MASTER"
                            ? "MASTER"
                            : "Name Not Provided"}
                        </LongerCardButton>
                      )}
                    </ButtonsContainer>
                  )}
                </StyledCard>
                </Fragment>
              ))}
            {curItemArray.length == 0 &&
              Object.keys(itemMap).length > 0 &&
              (searchActive ? (
                <div>No Search Results</div>
              ) : (
                <div>This Location Does Not Contain Any Items</div>
              ))}
            {localStorage.getItem("CognitoIdToken") != null &&
              curItemArray.length == 0 &&
              Object.keys(itemMap).length === 0 &&
              !subscriptionExpired && (
                <div>This account currently contains zero items.</div>
              )}
            {localStorage.getItem("CognitoIdToken") != null &&
              curItemArray.length == 0 &&
              Object.keys(itemMap).length === 0 &&
              subscriptionExpired && (
                <div>
                  Could not retrieve items since the subscription is expired.
                </div>
              )}
            {localStorage.getItem("CognitoIdToken") == null && (
              <div>You are not logged in</div>
            )}
          </CardContainer>

          {/* Multi-select bottom bar */}
          {multiSelectMode && !itemToMove && (
            <div style={{
              position: 'fixed',
              bottom: 0,
              left: 0,
              right: 0,
              backgroundColor: '#608cdf',
              color: 'white',
              padding: '15px 20px',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              boxShadow: '0 -2px 10px rgba(0,0,0,0.3)',
              zIndex: 9999,
              flexWrap: 'wrap',
              gap: '10px'
            }}>
              <div style={{ fontSize: '1.1rem', fontWeight: 'bold', minWidth: '150px' }}>
                {selectedItemsToMove.length} item{selectedItemsToMove.length !== 1 ? 's' : ''} selected
              </div>
              <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', justifyContent: 'flex-end', flex: '1' }}>
                <Button onClick={cancelMultiSelect} style={{ minWidth: '80px' }}>
                  Cancel
                </Button>
                <Button
                  onClick={moveSelectedItems}
                  disabled={selectedItemsToMove.length === 0}
                  style={{
                    ...(selectedItemsToMove.length === 0 ? { opacity: 0.5, cursor: 'not-allowed' } : {}),
                    minWidth: '120px',
                    width: 'auto',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}
                >
                  Select Location ({selectedItemsToMove.length})
                </Button>
              </div>
            </div>
          )}

          <LoadMoreContainer>
            {curItemArray.length > itemsInView && (
              <Button
                onClick={() =>
                  setItemsInView(
                    itemsInView +
                      parseInt(process.env.REACT_APP_ITEM_VIEW_INTERVAL!)
                  )
                }
              >
                Load More
              </Button>
            )}
          </LoadMoreContainer>
        </div>
      </div>
    </>
  );
}
